/*
 * @Description:
 * @Author: ZY
 * @Date: 2020-12-25 15:03:52
 * @LastEditors: fugang
 * @LastEditTime: 2022-05-11 14:30:42
 */

import { ActionTree, ActionContext } from 'vuex'
import { RootState, useStore } from '@/store'
import { PermissionState } from './state'
import { Mutations } from './mutations'
import { PermissionMutationType } from './mutation-types'
import { PermissionActionType } from './action-types'
import { UserActionTypes } from '../user/action-types'
import { asyncRoutes, resetRouter, addDynamicRoutes } from '@/router'
import { RouteRecordRaw } from 'vue-router'

type AugmentedActionContext = {
  commit<K extends keyof Mutations> (
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>
} & Omit<ActionContext<PermissionState, RootState>, 'commit'>

const hasPermission = (roles: string[], route: RouteRecordRaw) => {
  if (route.meta && route.meta.roles) {
    return roles.some(role => {
      if (route.meta?.roles !== undefined) {
        return route.meta.roles.includes(role)
      }
    })
  } else {
    return true
  }
}

export const filterAsyncRoutes = (routes: RouteRecordRaw[], roles: string[]) => {
  const res: RouteRecordRaw[] = []
  routes.forEach(route => {
    const r = { ...route }
    if (hasPermission(roles, r)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, roles)
      }
      res.push(r)
    }
  })
  return res
}

export interface Actions {
  [PermissionActionType.ACTION_SET_ROUTES] (
    { commit }: AugmentedActionContext
    , roles: string[]): void
  [PermissionActionType.ACTION_RESET_ROUTES] (
    { commit }: AugmentedActionContext): void
  [PermissionActionType.ACTION_GENERATE_ROUTES] (): Promise<void>
}

export const actions: ActionTree<PermissionState, RootState> & Actions = {
  [PermissionActionType.ACTION_SET_ROUTES] (
    { commit }: AugmentedActionContext
    , roles: string[]) {
    const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
    commit(PermissionMutationType.SET_ROUTES, accessedRoutes)
  },
  [PermissionActionType.ACTION_RESET_ROUTES] (
    { commit }: AugmentedActionContext) {
    commit(PermissionMutationType.SET_ROUTES, [])
    commit(PermissionMutationType.SET_ROUTE_LOADED, { role: '', loginId: '' })
  },
  async [PermissionActionType.ACTION_GENERATE_ROUTES] () {
    const store = useStore()
    resetRouter()
    store.dispatch(PermissionActionType.ACTION_RESET_ROUTES, undefined)
    await store.dispatch(UserActionTypes.ACTION_GET_USER_INFO, undefined)
    const roles = store.state.user.roles
    store.dispatch(PermissionActionType.ACTION_SET_ROUTES, roles)
    addDynamicRoutes(store.state.permission.dynamicRoutes)
    store.commit(PermissionMutationType.SET_ROUTE_LOADED, {
      role: localStorage.getItem('systempremmsion') ?? '',
      loginId: localStorage.getItem('loginId') ?? ''
    })
  }
}
